export default __webpack_public_path__ + "static/media/orederrecieved.83cd9c52.svg";